export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100; 
